<footer>
    <div [@animateFooter]>
        <ul class="footer-left-bar d-none d-md-block">
            <li>
                <a href="https://github.com/Pa1mekala37" target='_blank'>
                    <i class="fab fa-github"></i>
                </a>
            </li>
            <li>
                <a href="https://www.linkedin.com/in/pavan-mekala-5233b1202/" target='_blank'>
                    <i class="fab fa-linkedin-in"></i>
                </a>
            </li>
            <li>
                <a href="https://www.hackerrank.com/profile/pavanmekala72826" target='_blank'>
                    <i class="fab fa-hackerrank"></i>
                </a>
            </li>
            <!-- <li>
                <a  href="https://api.whatsapp.com/send?phone=919908773268&text=Hi!%20" target='_blank'>
                    <i class="fab fa-whatsapp"></i>
                </a>
            </li> -->
            <li>
                <a href="https://instagram.com/iam_pvn" target='_blank'>
                    <i class="fab fa-instagram"></i>
                </a>
            </li>
            <li>
                <a href="https://twitter.com/iampvn37" target='_blank'>
                    <i class="fab fa-twitter"></i>
                </a>
            </li>
        </ul>
        <div class="footer-right-bar d-none d-md-block">
            <a href="mailto:pavanmekala0129@gmail.com" target='_blank'>pavanmekala0129&#64;gmail.com </a>
        </div>
    </div>

</footer>